import { createStore, Store } from "@quotientjs/browser-storage"

import { stringValidator } from "@/stores/utils/validators"

export const DEVICE_ID_KEY = "quotient-device-id"

export type DeviceId = string

export const DeviceIdStore: Store<DeviceId, "local"> = createStore({
  key: DEVICE_ID_KEY,
  validator: stringValidator,
  storageType: "local",
})
